var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEvaluatorsFormIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 21,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#evaluators-form-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M2 20.3c-.3 0-.5 0-.8-.1-.2-.1-.5-.3-.6-.4-.2-.2-.3-.4-.4-.7-.1-.2-.2-.5-.1-.8V2c0-.3 0-.5.1-.8C.3 1 .5.7.6.5c.2-.2.4-.3.6-.4.3-.1.5-.1.8-.1h8l6 6.1v3c-.4 0-.7.2-1.1.4-.3.2-.7.4-.9.7l-6 6.1v4zM9 7.1h5L9 2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M18.9 13c0-.2-.2-.4-.3-.5l-.9-.9c-.1-.1-.3-.3-.5-.3s-.4-.1-.6-.1-.4 0-.5.1c-.2 0-.4.2-.5.3l-5.5 5.6v3.1h3.1l5.5-5.6c.1-.1.3-.3.3-.5v-.6c0-.2 0-.4-.1-.6m-2.3 1.6-.9-1 .9-1 .9.9-.9 1z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "evaluators-form-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h19v21H0z"
})))));
export { SvgEvaluatorsFormIcon as ReactComponent };
export default __webpack_public_path__ + "894497193d781c64524df685a483f140.svg";